import { render, staticRenderFns } from "./Comparative.vue?vue&type=template&id=15684140&scoped=true"
import script from "./Comparative.vue?vue&type=script&lang=js"
export * from "./Comparative.vue?vue&type=script&lang=js"
import style0 from "./Comparative.vue?vue&type=style&index=0&id=15684140&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "15684140",
  null
  
)

export default component.exports